

// this function is used to get the favorite from the state that matches the id of the action.payload.id
export default function getFavoriteFromState(state, id) {
    return state.userProfile?.favorites?.find((fav) => fav.listingId === id);
  }